import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRoboto, theme, ZIndexLayer } from "shared/lib/styles";

import { NotificationItem } from "scmp-app/components/news-ticker/notification-item";
import { CloseButton as NotificationItemCloseButton } from "scmp-app/components/news-ticker/notification-item/styles";

export const StyledNotificationItem = styled(NotificationItem)`
  z-index: ${ZIndexLayer.EditionInvitation};

  /* TODO: hide it first, will update it when the new tickers ticker is created */
  display: none;

  background: #ffca05;

  ${NotificationItemCloseButton} {
    background: #cca512;
  }
`;

export const UnknownGeoContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;

  ${theme.breakpoints.only("mobile")} {
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const Text = styled.div`
  display: inline;

  color: #001246;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 21px;

  ${theme.breakpoints.up("desktop")} {
    font-size: 14px;
    line-height: 16px;
  }
`;

export const EditionText = styled.div`
  display: inline;

  font-weight: bold;
`;

export const EditionGroup = styled.div`
  display: inline-block;

  margin-inline-start: 0;

  ${theme.breakpoints.up("desktop")} {
    margin-inline-start: 4px;
  }
`;

export const StyledBaseLink = styled(BaseLink)`
  color: #001246;
  font-weight: bold;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 21px;

  &:not(:last-child):after {
    content: "|";

    margin-block: 0;
    margin-inline: 4px;

    font-size: 14px;
    font-family: ${fontRoboto};
    line-height: 16px;
  }
`;

export const YesButtonLink = styled(BaseLink)`
  flex: 0 0 auto;

  inline-size: 45px;
  block-size: 25px;
  margin-block: 0;
  margin-inline: 16px;

  color: #ffffff;
  line-height: 25px;
  text-align: center;

  border-radius: 2px;

  background: #001246;
`;
